import { useTranslation } from "react-i18next";
import { ErrorPage } from "components/errors/ErrorPage";
import { CRASH_COPY, crashKind } from "components/errors/crashKind";

/**
 * The page either boundary shows for a crash: the sentence for its kind, the
 * error folded away beneath it, and a reload (Jira NAV-169).
 *
 * The retry is a full reload rather than a re-render: after the Firestore SDK's
 * internal assertion its async queue is dead and every later read throws again,
 * so re-rendering would fail the same way.
 *
 * `offerBack` only where a router is mounted, since the way back is a `Link`.
 */
export function CrashPage({
  error,
  offerBack = false,
}: {
  error: unknown;
  offerBack?: boolean;
}) {
  const { t } = useTranslation(["error"]);
  const copy = CRASH_COPY[crashKind(error)];
  // A thrown `null` or `undefined` has nothing to show; `String()` would print
  // the word itself as the technical detail.
  const detail =
    error instanceof Error ? error : error == null ? undefined : String(error);

  return (
    <ErrorPage
      title={t(copy.title)}
      message={t(copy.message)}
      error={detail}
      onRetry={() => window.location.reload()}
      offerBack={offerBack}
    />
  );
}
